import React from 'react';

/**
 * Horizontal, scrollable section tabs for the help drawer. Receives the
 * already role-filtered sections from HelpDrawer.
 */
export default function HelpNav({ sections, activeSection, onSectionChange }) {
  return (
    <div
      role="tablist"
      style={{
        display: 'flex',
        borderBottom: '1px solid #e5e7eb',
        overflowX: 'auto',
        flexShrink: 0,
      }}
    >
      {sections.map((section) => {
        const isActive = section.id === activeSection;
        return (
          <button
            key={section.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onSectionChange(section.id)}
            style={{
              flexShrink: 0,
              display: 'inline-flex',
              alignItems: 'center',
              gap: 6,
              whiteSpace: 'nowrap',
              padding: '12px 14px',
              fontSize: 13,
              fontWeight: 500,
              border: 'none',
              background: isActive ? '#f5f3ff' : 'transparent',
              color: isActive ? '#667eea' : '#6b7280',
              borderBottom: isActive ? '2px solid #667eea' : '2px solid transparent',
              cursor: 'pointer',
            }}
          >
            <i className={section.icon} />
            <span>{section.title}</span>
          </button>
        );
      })}
    </div>
  );
}
